import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import MemeCard from "../components/MemeCard";

const API_BASE = import.meta.env.VITE_API_BASE ?? "https://app.memesec-factory.com/api/v1";

interface Meme {
  id: number;
  title: string;
  top_text: string;
  bottom_text: string;
  s3_url: string;
  web_url: string;
  thumbnail_url?: string;
  mitre_technique_id?: string;
  mitre_tactic?: string;
  view_count: number;
  like_count: number;
}

const TACTICS = [
  "Reconnaissance", "Resource Development", "Initial Access", "Execution",
  "Persistence", "Privilege Escalation", "Defense Evasion", "Credential Access",
  "Discovery", "Lateral Movement", "Collection", "Command and Control",
  "Exfiltration", "Impact",
];

const Gallery: React.FC = () => {
  const navigate = useNavigate();
  const [memes, setMemes] = useState<Meme[]>([]);
  const [loading, setLoading] = useState(true);
  const [tactic, setTactic] = useState<string>("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams({ page: String(page), limit: "24" });
    if (tactic) params.set("tactic", tactic);

    axios.get(`${API_BASE}/memes/?${params}`)
      .then((res) => setMemes(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [page, tactic]);

  return (
    <div className="gallery-page">
      <div className="gallery-header">
        <h1>Meme Gallery</h1>
        <div className="filters">
          <select value={tactic} onChange={(e) => { setTactic(e.target.value); setPage(1); }}>
            <option value="">All Tactics</option>
            {TACTICS.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
      </div>

      {loading ? (
        <div className="loading">Generating memes from ATT&CK database...</div>
      ) : (
        <div className="meme-grid">
          {memes.map((meme) => (
            <MemeCard key={meme.id} meme={meme} onClick={(m) => navigate(`/memes/${m.id}`)} />
          ))}
        </div>
      )}

      <div className="pagination">
        <button disabled={page === 1} onClick={() => setPage(p => p - 1)}>← Prev</button>
        <span>Page {page}</span>
        <button onClick={() => setPage(p => p + 1)}>Next →</button>
      </div>
    </div>
  );
};

export default Gallery;
